import { HttpErrorResponse } from "@angular/common/http";

import { User } from "@core/models/user.model";
import { createReducer, on } from "@ngrx/store";

import * as AuthActions from "../store/auth.actions";

export const AUTH_FEATURE_KEY = "auth";

export interface AuthState {
  user: User | undefined;
  loading: boolean;
  loginError: HttpErrorResponse | null;
}

const initialState: AuthState = {
  user: undefined,
  loading: false,
  loginError: null,
};

export const AUTH_REDUCER = createReducer(
  initialState,
  on(AuthActions.LOGIN_SUCCESS, (state: AuthState, action: User): AuthState => {
    return {
      ...state,
      loading: false,
      user: action,
    };
  }),
  on(
    AuthActions.LOGIN_FAILED,
    (state: AuthState, action: { error: HttpErrorResponse }): AuthState => {
      return {
        ...state,
        loading: false,
        loginError: action.error,
      };
    }
  ),
  on(
    AuthActions.SET_LOGIN_LOADING,
    (state: AuthState, action: { loading: boolean }): AuthState => {
      return {
        ...state,
        loading: action.loading,
      };
    }
  ),
  on(
    AuthActions.SET_USER_DATA,
    (state: AuthState, action: { user: User }): AuthState => {
      return {
        ...state,
        user: action.user,
      };
    }
  )
);
